import React from 'react';
import { convertToSlug, getIconSrcFromSrcList } from 'globals/utils';
import iconDefaultFallbackSrc from 'assets/icons/banks/default-fallback.svg';
import * as IconSources from 'assets/icons/banks';
import { FsComponentSize } from 'globals/types';
import { LogoWrapperBox } from './FsBankLogoLoader.style-elements';

const iconSrcList = Object.values(IconSources);

interface FsBankLogoLoaderProps {
  bankName: string;
  size?: FsComponentSize.S | FsComponentSize.M;
}

const FsBankLogoLoader: React.FC<FsBankLogoLoaderProps> = ({
  bankName,
  size,
}) => {
  const iconSrc = bankName
    ? getIconSrcFromSrcList(
        iconSrcList,
        convertToSlug(bankName),
        iconDefaultFallbackSrc
      )
    : iconDefaultFallbackSrc;
  return (
    <LogoWrapperBox data-test="bank-icon-loader" size={size}>
      <img src={iconSrc} alt={bankName} />
    </LogoWrapperBox>
  );
};

FsBankLogoLoader.displayName = 'BankLogoLoader';

export default FsBankLogoLoader;
